export enum ExtendedDescriptionType {
  String = 0,
  ImagesAndTexts = 1,
}
